import { AnimatePresence } from 'framer-motion'

import { LOCAL_STORAGE_KEY_MAP } from '@/lib/constants/platform'
import { useRedirect } from '@/lib/hooks/use-redirect'
import { cn } from '@/lib/utils'

import { IndependentPageTopBar } from '../ui/individual-page-top-bar/individual-page-top-bar'
import { ACCOUNT_DELETION_STEP_MAP } from './constants'
import { AccountVerificationCard } from './ui/account-verification-card/account-verification-card'
import { ConfirmWithSubscriptionCard } from './ui/confirm-with-subscription-card/confirm-with-subscription-card'
import { ConfirmWithoutSubscriptionCard } from './ui/confirm-without-subscription-card/confirm-without-subscription-card'
import { GuideToUnsubscribeCard } from './ui/guide-to-unsubscribe-card/guide-to-unsubscribe-card'
import { StepAnimation } from './ui/step-animation/step-animation'
import { useDeleteAccountPage } from './use-page'

export const DeleteAccountPage = () => {
  const { currentStep, subscriptionExpiryDate, backToSettingsPage, handleSuccessAccountVerification } =
    useDeleteAccountPage()

  const loginToken = localStorage.getItem(LOCAL_STORAGE_KEY_MAP.token)
  useRedirect({ condition: !loginToken, redirectTo: '/' })

  return (
    <>
      <IndependentPageTopBar />
      <main className={cn('px-4 py-[100px]')}>
        <div className={cn('relative', 'flex justify-center')}>
          <AnimatePresence initial={false}>
            {currentStep === ACCOUNT_DELETION_STEP_MAP.verifyAccount && (
              <StepAnimation key="step-1">
                <AccountVerificationCard onSuccess={handleSuccessAccountVerification} />
              </StepAnimation>
            )}

            {currentStep === ACCOUNT_DELETION_STEP_MAP.guideToUnsubscribe && (
              <StepAnimation key="step-2-guide-to-unsubscribe" slideInFromRight>
                <GuideToUnsubscribeCard
                  subscriptionExpiryDate={subscriptionExpiryDate}
                  onClickButton={backToSettingsPage}
                />
              </StepAnimation>
            )}

            {currentStep === ACCOUNT_DELETION_STEP_MAP.confirmWithSubscription && (
              <StepAnimation key="step-2-with-subscription" slideInFromRight>
                <ConfirmWithSubscriptionCard
                  subscriptionExpiryDate={subscriptionExpiryDate}
                  onClickCancelButton={backToSettingsPage}
                />
              </StepAnimation>
            )}

            {currentStep === ACCOUNT_DELETION_STEP_MAP.confirmWithoutSubscription && (
              <StepAnimation key="step-2-without-subscription" slideInFromRight>
                <ConfirmWithoutSubscriptionCard onClickCancelButton={backToSettingsPage} />
              </StepAnimation>
            )}
          </AnimatePresence>
        </div>
      </main>
    </>
  )
}
